// 这个mixin的作用是:
// 1. 每当给组件的query赋值时，在nextTick后query值与默认query值不一致的将会放入url中，同时进行一次refresh以新query请求一次
// 2. 当从某个url进来时将route.query的值同步到query中
// 3. 默认query的值除了同步到this.query，同时也同步到asyncQuery中做非响应式刷新，非响应式刷新的数据可以放入asyncQuery中，
// 在某个时机需要触发search时把asyncQuery同步到this.query即可，主要应用于类似文字搜索框不需要实时请求的类型
export default (defineQuery, type = 'push') => {
  return {
    created() {
      Object.assign(this.query, this.$route.query)
      if (this.asyncQuery) {
        Object.assign(this.asyncQuery, defineQuery, this.$route.query)
      }
    },
    watch: {
      query: {
        handler(val, oldVal) {
          const query = {}
          for (const i in val) {
            if (val[i] !== defineQuery[i]) {
              query[i] = val[i]
            }
          }
          this.$router[type]({ path: this.$route.path, query })
        },
        deep: true
      },
      $route(val, oldVal) {
        Object.assign(this.query, defineQuery, val.query)
        if (this.asyncQuery) {
          Object.assign(this.asyncQuery, defineQuery, val.query)
        }
        this.refresh()
      }
    },
    methods: {
      search(query) {
        if (typeof query !== 'object') return
        this.query.page = 1
        for (const i in query) {
          this.query[i] = query[i]
        }
      }
    }
  }
}
